var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEstrutura = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 125,
  height: 121,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M90.252 120.071l4.734-18.348 27.448-.322 1.896 19.314",
  fill: "url(#paint0_linear)"
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M74.684 35.735a20.614 20.614 0 01-2.013-2.37 8.65 8.65 0 01-.98-1.57 11.407 11.407 0 01-.606-1.803l-1.045-3.798a.683.683 0 010-.284.515.515 0 01.477-.437c.244-.014.484.054.684.193a3.54 3.54 0 011.29 1.725c.27.657.619 2.949 1.78 2.19a1.288 1.288 0 00.516-1.134 2.02 2.02 0 00-.58-1.365c-.516-.515-1.29-.72-1.768-1.287a1.737 1.737 0 010-2.138 2.173 2.173 0 01.18-2.498 1.288 1.288 0 01-.412-1.635 1.83 1.83 0 011.47-.966c2.76-.283 4.463 3.27 5.289 5.357a17.219 17.219 0 003.018 5.858",
  fill: "#C1813E"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M112.36 62.439L90.51 43.537l-8.616-15.76-9.906 9.013 12.898 19.443a15.974 15.974 0 003.07 3.45l12.292 10.378",
  fill: "#079D56"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M95.579 66.547l.103 1.403-5.172-24.412 19.257 16.365",
  fill: "#079D56"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M72.517.069L72.4 37.524l-.168 59.77v13.816a1.002 1.002 0 001 .89 1.003 1.003 0 001-.89l.064-37.392.18-59.77.039-13.88a1.003 1.003 0 00-1-.89 1.007 1.007 0 00-1 .89zM49.274.004l-.103 37.456-.18 59.77v13.815a1.005 1.005 0 102.011 0l.104-37.455.18-59.77V.004A1.003 1.003 0 0050.28-1 1.007 1.007 0 0049.274.004zM26.018 9.107l-.09 31.404-.142 49.778v11.524a1.005 1.005 0 002.012 0l.09-31.417.142-49.778V9.108a1.003 1.003 0 00-1.006-1.005 1.007 1.007 0 00-1.006 1.004zM95.708 13.047l-.22 74.59v10.636a1.004 1.004 0 001 .89 1.007 1.007 0 001-.89l.219-74.603V13.047a1.003 1.003 0 00-1-.89 1.007 1.007 0 00-1 .89z",
  fill: "#AC41D8"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M7.806 30.327l37.611.116 60.016.167h13.866a1.005 1.005 0 100-2.009l-37.612-.103-60.015-.128H7.806a1.007 1.007 0 00-.892.997 1.003 1.003 0 00.892.998v-.038zM.84 72.225l31.602.09 50.42.116H94.47a1.007 1.007 0 00.892-.998 1.004 1.004 0 00-.892-.998l-31.588-.09-50.381-.09H.892a1.007 1.007 0 00-.892.998 1.003 1.003 0 00.892.998l-.051-.026zM10.824 93.16l31.6.09 50.42.142h11.609a1.005 1.005 0 100-2.008l-31.601-.09-50.42-.142H10.824a1.007 1.007 0 00-1.006 1.004 1.003 1.003 0 001.006 1.004zM5.033 51.263l33.535.103 53.838.154h12.318a1.006 1.006 0 000-1.996l-33.536-.102-53.799-.168H5.033a1.006 1.006 0 00-.893.998 1.003 1.003 0 00.893.998v.013z",
  fill: "#AC41D8"
}))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M63.913 99.87l-3.869.218c-2.115.116-4.192.322-6.307.438-.477 0-1.11.206-1.11.682a.78.78 0 00.439.605c.59.287 1.22.479 1.87.567a2.018 2.018 0 011.51 1.12 1.955 1.955 0 01-.93 2.035 5.35 5.35 0 01-4.617.643 7.172 7.172 0 00-1.29-.257 1.458 1.458 0 00-1.16.425 1.68 1.68 0 00-.09 1.712 6.644 6.644 0 004.604 3.734c4.192 1.12 9.029-.721 13.027-2.073M101.9 68.233l-2.812-7.97c-1.51-.798-2.8-1.287-4.244-2.15a4.382 4.382 0 01-2.102-2.073 4.254 4.254 0 01.683-3.27 51.972 51.972 0 012.4-4.082c-.645-.425-1.368-1.03-1.29-1.803.077-.772.645-.991 1.16-1.287l3.78-2.357a13.674 13.674 0 013.302-1.712 11.843 11.843 0 012.012-.4 10.773 10.773 0 015.391.245 6.93 6.93 0 013.264 2.215 9.164 9.164 0 011.109 7.816 16.569 16.569 0 01-4.295 6.862l2.837 6.22",
  fill: "#C1813E"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M99.487 47.967a.4.4 0 100-.8.4.4 0 000 .8z",
  fill: "#2B2B2B"
})), /*#__PURE__*/React.createElement("g", {
  style: {
    mixBlendMode: "multiply"
  }
}, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M95.734 51.083a2.582 2.582 0 002.102.335.249.249 0 10-.142-.477 2.068 2.068 0 01-1.728-.296c-.258-.18-.49.258-.232.438z",
  fill: "#C1813E"
}))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M107.523 61.113l-14.188 5.536A9.66 9.66 0 0089.58 69.3a9.638 9.638 0 00-2.101 4.083l-2.58 10.777a8.055 8.055 0 01-3.87 5.15L61.787 99.883l5.159 12 26.828-12.605-.49 8.536 30.027-.257V90.817a54.798 54.798 0 00-6.707-26.421 7.31 7.31 0 00-3.92-3.35 7.324 7.324 0 00-5.16.067z",
  fill: "#00D38D"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M107.523 61.113l-14.188 5.536A9.66 9.66 0 0089.58 69.3a9.638 9.638 0 00-2.101 4.083l-2.58 10.777a8.055 8.055 0 01-3.87 5.15L61.787 99.883l5.159 12 26.828-12.605-.49 8.536 30.027-.257V90.817a54.798 54.798 0 00-6.707-26.421 7.31 7.31 0 00-3.92-3.35 7.324 7.324 0 00-5.16.067z",
  fill: "url(#paint1_linear)"
}), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  d: "M113.224 56.98c.838-1.133 1.664-2.24 2.579-3.283a7.81 7.81 0 001.806-3.374 5.96 5.96 0 000-1.069c0-1.587-.588-3.119-1.651-4.3a10.232 10.232 0 00-4.101-3.013c-1.2-.464-2.49-.657-3.638-1.288-1.896-.953-3.444-2.459-5.469-3.18a2.827 2.827 0 00-2.889.373 2.264 2.264 0 00-.451 2.408c.89 2.318 5.894 2.575 5.559 5.653a5.51 5.51 0 01-.632 1.545 1.511 1.511 0 000 1.57 1.367 1.367 0 001.161.374c.606 0 1.289-.425 1.896-.193a1.936 1.936 0 011.122 1.97 2.838 2.838 0 01-1.29 1.996 5.228 5.228 0 01-2.27.81 4.474 4.474 0 00-.722.142 5.64 5.64 0 00.309 4.43 3.992 3.992 0 003.147 1.52 6.113 6.113 0 003.109-.658 7.117 7.117 0 002.425-2.433z",
  fill: "#2B2B2B"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  d: "M115.623 53.632L98.197 37.357a1.531 1.531 0 01-.09-2.138 1.523 1.523 0 012.102-.128l1.29 1.107a6.354 6.354 0 006.965.734l1.29-.631a8.617 8.617 0 0110.241 1.738 8.563 8.563 0 01.594 11.048l-3.341 4.416a1.073 1.073 0 01-1.625.129z",
  fill: "#EE8322"
})), /*#__PURE__*/React.createElement("path", {
  style: {
    mixBlendMode: "multiply"
  },
  d: "M115.623 53.632L98.197 37.357a1.531 1.531 0 01-.09-2.138 1.523 1.523 0 012.102-.128l1.29 1.107a6.354 6.354 0 006.965.734l1.29-.631a8.617 8.617 0 0110.241 1.738 8.563 8.563 0 01.594 11.048l-3.341 4.416a1.073 1.073 0 01-1.625.129z",
  fill: "url(#paint2_linear)"
}), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  d: "M99.087 60.263l2.825.76-2.193 1.017",
  fill: "#C1813E"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M25.954 30.378h2.012l-2.012 3.245M49.197 30.43h1.999l-2.012 3.244M95.643 30.584h2.012L95.63 33.83M25.89 51.315H27.9l-2.025 3.244M49.12 51.417h2.011l-2.025 3.245M72.35 51.43h2.011l-2.012 3.245M25.825 72.276h1.999l-2.012 3.245M49.042 72.353h1.999l-2.012 3.245M72.284 72.392h2.013l-2.025 3.245M25.76 93.161h2l-2.013 3.245M48.964 93.251h2.012l-2.025 3.245",
  fill: "#AC41D8"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 107.291,
  y1: 101.401,
  x2: 107.291,
  y2: 120.715,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#006B3F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear",
  x1: 108.078,
  y1: 116.324,
  x2: 82.863,
  y2: 72.573,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00D38D"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear",
  x1: 97.707,
  y1: 44.323,
  x2: 122.304,
  y2: 44.323,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EE8322"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEstrutura);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/estrutura.7fedf5246540d73d659bdc09a77bae8b.svg";